// SwiperのTurbolinksイベントをハンドリングする関数
export function handleSwiperTurbolinks() {
  document.addEventListener('turbolinks:load', () => {
    initializeSwiper(
      '.swiper-container.latestCaseList',
      '.swiper-pagination.latestCaseList',
      '.swiper-button-next.latestCaseList',
      '.swiper-button-prev.latestCaseList',
      'latestCaseListSwiper'
    );

    initializeSwiper(
      '.swiper-container.rankingList',
      '.swiper-pagination.rankingList',
      '.swiper-button-next.rankingList',
      '.swiper-button-prev.rankingList',
      'rankingListSwiper'
    );
  });

  document.addEventListener('turbolinks:before-cache', () => {
    destroySwipers();
  });
}

// Swiperを初期化する関数
function initializeSwiper(
  containerSelector,
  paginationSelector,
  nextElSelector,
  prevElSelector,
  swiperVariable
) {
  const swiperContainer = document.querySelector(containerSelector);
  if (!swiperContainer) return;

  // 既存のSwiperインスタンスがあれば破棄
  if (window[swiperVariable]) {
    window[swiperVariable].destroy(true, true);
    window[swiperVariable] = null;
  }

  const slides = swiperContainer.querySelectorAll('.swiper-slide').length;
  let slidesPerView = determineSlidesPerView(window.innerWidth);
  const shouldLoop = slides > slidesPerView;

  // Swiperを初期化
  window[swiperVariable] = new Swiper(containerSelector, {
    slidesPerView: slidesPerView,
    loop: shouldLoop,
    observer: true, // DOMの変化を監視
    observeParents: true, // 親要素の変化も監視
    breakpoints: {
      500: {
        slidesPerView: 2,
      },
      900: {
        slidesPerView: 4,
      },
    },
    pagination: {
      el: paginationSelector,
      clickable: true,
    },
    navigation: {
      nextEl: nextElSelector,
      prevEl: prevElSelector,
    },
  });
}

// ウィンドウ幅に応じて表示スライド数を決定する関数
function determineSlidesPerView(windowWidth) {
  if (windowWidth >= 900) {
    return 4;
  } else if (windowWidth >= 500) {
    return 2;
  }
  return 1;
}

// 全てのSwiperインスタンスを破棄する関数
function destroySwipers() {
  const swipers = ['latestCaseListSwiper', 'rankingListSwiper'];
  swipers.forEach((swiperVar) => {
    if (window[swiperVar]) {
      window[swiperVar].destroy(true, true);
      window[swiperVar] = null;
    }
  });
}
